const header = document.getElementsByClassName('shopify-section--header');

function scrollFunction() {
    if(document.documentElement.scrollTop >= 100){
            header[0].classList.add("scrolled");            
        }else{            
            header[0].classList.remove("scrolled");
        }   
   }
   window.onscroll = function () {
     scrollFunction();
   };
   